module.exports = __webpack_public_path__ + "static/media/CHOPL_MENU-normal.f834e43a.png";